// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"3df368af","53":"02965e36","95":"84620504","324":"df0c1d6d","488":"14fbbebc","623":"669b36ea","659":"c674873c","707":"a591d6a6","744":"ba8e82ad","901":"bdfe5e1b","908":"21d45b4d","925":"01166eb5"}[chunkId] + ".chunk.js";
};